import { getPresignedUrl } from "../components/common/actions";

let profileImageUrlCache = {
    image: "",
    url: "",
    request: null
};

export const getUserProfileImageUrl = async image => {
    if (!image || image === "null") return "";

    if (profileImageUrlCache.image === image && profileImageUrlCache.url) {
        return profileImageUrlCache.url;
    }

    if (profileImageUrlCache.image === image && profileImageUrlCache.request) {
        return await profileImageUrlCache.request;
    }

    profileImageUrlCache = {
        image,
        url: "",
        request: getPresignedUrl(image)
    };

    const url = await profileImageUrlCache.request;
    profileImageUrlCache = {
        image,
        url: url || "",
        request: null
    };
    return url || "";
};
